import React, { Component } from 'react';
import styled from 'styled-components';
import { Form } from 'react-final-form';
import { func } from 'prop-types';

import Text from '../../components/Field/Text';
import FilterButton from '../../components/Field/FilterButton';
import ResetButton from '../../components/Field/ResetButton';

export default class AgenciesListFilters extends Component {
  static propTypes = {
    onSubmit: func,
  };

  render() {
    return (
      <Form onSubmit={this.props.onSubmit}>
        {({ handleSubmit, submitting, form }) => (
          <form onSubmit={handleSubmit}>
            <FiltersRow>
              <Row>
                <TextField name="ragioneSociale" placeholder="Ragione Sociale" />
                <TextField name="email" placeholder="Email" />
              </Row>
              <FilterButton
                onClick={handleSubmit}
                loading={submitting}
                disabled={submitting}
              />
              <ResetButton onClick={form.reset} />
            </FiltersRow>
          </form>
        )}
      </Form>
    );
  }
}

const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0;
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  & > div:first-child {
    margin-left: 0;
  }
`;

const TextField = styled(Text)`
  margin-right: 16px;
  flex: 1;
`;
